import React, {Component} from "react";
import {Icon} from "bloomer";
import Card from "../../../elements/Card";
import Button from "../../../elements/Button";
import {getFearAndGreedIndex} from "../../../api/models/FearAndGreedIndex";
import SendGAEvent, {GAEventActions, GAEventModels} from "../../../utils/SendGAEvent";
import InformationCard from "../../../elements/InformationCard";
import Spacer from "../../../elements/Spacer";
import ModelContentContainer from "../../../elements/ModelContentContainer";
import Moment from "moment";
import FearAndGreedValueChart from "./FearAndGreedValueChart";
import FearAndGreedValue from "./FearAndGreedValue";
import "./style.css";
import ErrorUtils from "../../../utils/ErrorUtils";
import {toast} from "react-toastify";

interface IFearAndGreedIndexModelState {
    loading: boolean;
    result: any;
    showRefreshButton: boolean;
    errorMessage: string;
}

class FearAndGreedIndexModel extends Component<{}, IFearAndGreedIndexModelState> {

    public constructor(props: {}) {
        super(props);

        this.state = {
            loading: false,
            result: null,
            showRefreshButton: false,
            errorMessage: ""
        };
    }

    public componentDidMount() {
        SendGAEvent(GAEventActions.VIEW_MODEL, GAEventModels.FEAR_AND_GREED_INDEX);
        this.loadReport();
    }

    public loadReport = async () => {
        if (this.state.loading) {
            this.setState({result: null});
            return;
        }

        this.setState({
            loading: true,
            result: null,
            errorMessage: ""
        });

        let errorOccurred = false;

        const response = await getFearAndGreedIndex().catch((error) => {
            if (ErrorUtils.requestLimitExceeded(error.response)) {
                this.setState({
                    loading: false,
                    showRefreshButton: true
                });
                toast.error(ErrorUtils.messageContent.REQUEST_LIMIT_EXCEEDED);
            } else {
                this.setState({
                    loading: false,
                    showRefreshButton: true,
                    errorMessage: "Couldn't get data."
                });
            }
            errorOccurred = true;
        });

        if (errorOccurred) {
            return;
        }

        if (response && response.data) {
            this.setState({
                loading: false,
                showRefreshButton: true,
                result: response.data
            });
        } else {
            this.setState({
                loading: false,
                showRefreshButton: true,
                errorMessage: "Couldn't get data."
            });
        }

        SendGAEvent(GAEventActions.CALL_MODEL, GAEventModels.FEAR_AND_GREED_INDEX);
    };

    public onRefresh = (e: any) => {
        e.target.blur();
        this.loadReport();
    };

    public render() {
        return <ModelContentContainer>
            <Card>
                {
                    this.state.loading && <div className="LoadingMaskContainer">
                        <span>Loading...</span>
                        <Icon className="fas fa-spinner fa-spin"/>
                    </div>
                }
                <Spacer/>
                {
                    !this.state.loading && this.state.result ? <div>
                        <div className="HeaderContainer">
                            <div className="RefreshButtonContainer">
                                {
                                    this.state.showRefreshButton ?
                                        <Button onClick={this.onRefresh}>
                                            <Icon className="fas fa-sync-alt" style={{marginRight: '5px'}}/>
                                            {"Refresh"}
                                        </Button> : <></>
                                }
                            </div>
                            <div className="LastUpdateTime">
                                {"Last updated at "}
                                {
                                    (this.state.result.lastUpdate && this.state.result.lastUpdate.humanDate) ?
                                        Moment.utc(this.state.result.lastUpdate.humanDate).format('YYYY/MM/DD HH:mm') : ""
                                }
                            </div>
                        </div>
                        <Spacer/>
                        <div className="MainContainer">
                            <div className="CurrentDataContainer">
                                <FearAndGreedValueChart data={this.state.result.fgi.now}/>
                            </div>
                            <div className="HistoryDataContainer">
                                <FearAndGreedValue period="Previous Close" data={this.state.result.fgi.previousClose}/>
                                <FearAndGreedValue period="1 Week Ago" data={this.state.result.fgi.oneWeekAgo}/>
                                <FearAndGreedValue period="1 Month Ago" data={this.state.result.fgi.oneMonthAgo}/>
                                <FearAndGreedValue period="1 Year Ago" data={this.state.result.fgi.oneYearAgo}/>
                            </div>
                        </div>
                    </div> : <></>
                }
                {
                    !this.state.loading && !this.state.result && this.state.showRefreshButton ? <div>
                        <div className="HeaderContainer">
                            <div className="RefreshButtonContainer">
                                <Button onClick={this.onRefresh}>
                                    <Icon className="fas fa-sync-alt" style={{marginRight: '5px'}}/>
                                    {"Refresh"}
                                </Button>
                            </div>
                        </div>
                        <Spacer/>
                    </div> : <></>
                }
                {
                    !this.state.loading && this.state.errorMessage ? <div>
                        <InformationCard>{this.state.errorMessage}</InformationCard>
                    </div> : <></>
                }
            </Card>
        </ModelContentContainer>;
    }
}

export default FearAndGreedIndexModel;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/FearAndGreedIndex/FearAndGreedIndexModel.tsx